import {
  ACCOUNT_SETUP_REQUEST,
  ACCOUNT_SETUP_SUCCESS,
  ACCOUNT_SETUP_FAILURE,
  RESET_ACCOUNT_SETUP_STATE,
} from "../../actionTypes/accountSetup";

export interface AccountSetupPayload {
  invitationToken: string;
  accountOwnerFirstName: string;
  accountOwnerLastName: string;
  phoneType: string;
  phoneNumber: string;
  accountName: string;
  accountOwnerEmail: string;
  accountType: string;
  country: string;
  password: string;
  confirmPassword: string;
  captchaInput: string;
}

export const accountSetupRequest = (params: AccountSetupPayload) => {
  return {
    type: ACCOUNT_SETUP_REQUEST,
    payload: params,
  };
};

export const accountSetupSuccess = () => {
  return {
    type: ACCOUNT_SETUP_SUCCESS,
  };
};

export const accountSetupFailure = (error?: string) => {
  return {
    type: ACCOUNT_SETUP_FAILURE,
    payload: error,
  };
};

export const resetAccountSetupState = () => {
  return {
    type: RESET_ACCOUNT_SETUP_STATE,
  };
};

